<template>
  <div class="upload-component">
    <div class="dropzone" @dragover.prevent @drop="handleDrop">
      <vs-icon
        icon-pack="feather"
        icon="icon-image"
        color="black"
        size="large"
      ></vs-icon>
      <p class="mt-8 mb-8 font-bold text-black">{{ texto }}</p>
      <label for="fileInput" class="custom-file-input font-bold">
        <vs-icon icon-pack="feather" icon="icon-image" color="white"></vs-icon>
        Clique aqui para fazer o upload
      </label>
      <input
        type="file"
        id="fileInput"
        ref="fileInput"
        class="hidden-file-input"
        @change="handleFileInput"
        tabindex="-1"
      />
    </div>
  </div>
</template>
<script>
import notify from '../../utils/notify';

export default {
  name: 'multiple-file-dropdown',
  props: ['texto', 'extensoesPermitidas'],
  data() {
    return {
      uploadedFiles: [],
    };
  },
  methods: {
    handleDrop(event) {
      event.preventDefault();
      this.handleFiles(event.dataTransfer.files);
    },
    handleFileInput() {
      this.handleFiles(this.$refs.fileInput.files);
    },
    handleFiles(files) {
      const extensoesPermitidas = this.extensoesPermitidas.split('-');
      for (let i = 0; i < files.length; i++) {
        const parts = files[i].name.split('.');
        const extensao = parts[parts.length - 1]
        if (extensoesPermitidas.includes(extensao.toLowerCase())) {
          this.uploadedFiles.push(files[i]);
        } else {
          notify.notifyFail(
            this.$vs,
            `O arquivo ${files[i].name} tem a extensão .${extensao} não permitida`,
          );
        }
      }

      if (this.uploadedFiles.length) {
        this.$emit('files', this.uploadedFiles);
        this.uploadedFiles = [];
      }
    },
  },
};
</script>
<style>
.upload-component {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dropzone {
  border-radius: 16px;
  border: 2px dashed #ccc;
  background: #f8f8f8;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  width: 100%;
}

.uploaded-files {
  margin-top: 20px;
}

.file {
  margin-bottom: 5px;
}

.hidden-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.custom-file-input {
  background-image: linear-gradient(90deg, #1ab7e8 0%, #5172b2 100%);
  color: white;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
